import React, { useEffect, useState } from 'react';
import { Divider, Typography, Container, Grid, TextField, Button } from '@material-ui/core';
import useReactRouter from 'use-react-router';
import HeaderMenu from '../Components/Header/headeradmission';
import CivilConferenceMenu from '../Components/Header/civilconferencemenu';
import Viewfield from '../Components/FormsUI/Viewfield';

// Shared page for Civil Conference "Payment" (mode="payment") and "Download" (mode="download").
const CivilConferenceLookup = ({ mode }) => {
  const { match } = useReactRouter();
  const instituteId = match.params.id;
  const [instInfo, setInstInfo] = useState({});
  const [regId, setRegId] = useState();
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_ROOT}/public/online-applicantion/institute-info/${instituteId}`)
      .then((r) => r.json())
      .then((d) => setInstInfo(d?.item || {}))
      .catch(() => {});
  }, [instituteId]);

  async function search(e) {
    e.preventDefault();
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_ROOT}/public/online/admission/single/applicant/info?instituteId=${instituteId}&registrationId=${regId}`
      );
      const content = await res.json();
      if (content?.messageType === 1) setData(content.item);
      else { alert('No Data Found'); setData(null); }
    } catch (err) {
      console.log(err);
    }
  }

  async function makePayment() {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_ROOT}/public/get/online-admission-fees-payment/spg/session-id?registrationId=${regId}&instituteId=${parseInt(instituteId)}`,
        { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }
      );
      const content = await res.json();
      if (content?.messageType === 1) window.open(content?.item);
      else alert(content?.message);
    } catch (err) {
      console.log(err);
    }
  }

  function downloadPdf() {
    window.open(
      `${process.env.REACT_APP_API_ROOT}/public/online/admission/icce-confirmation/letter/download?instituteId=${parseInt(instituteId)}&registrationId=${regId}`
    );
  }

  const isPayment = mode === 'payment';

  return (
    <Grid container>
      <Grid item xs={12}>
        <HeaderMenu details={{ instituteName: instInfo?.institutename, address: instInfo?.instituteaddress, image: instInfo?.imageLink }} />
      </Grid>
      <Grid item xs={12} style={{ background: '#fff', boxShadow: 'rgb(216 216 216) 0px 0px 15px 0px', padding: '15px' }}>
        <Divider />
        <CivilConferenceMenu />
        <Typography style={{ fontSize: '24px', textAlign: 'center', marginBottom: '10px', color: '#f68b1f', fontWeight: 500 }}>
          {isPayment ? 'Payment' : 'Download'}
        </Typography>
        <Divider />
        <br />
        <Container maxWidth="md">
          <form onSubmit={search}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField label="Registration Id" variant="outlined" fullWidth required type="number" onChange={(e) => setRegId(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button type="submit" color="primary" variant="contained" fullWidth style={{ height: 55, backgroundColor: '#009688' }}>Search</Button>
              </Grid>
            </Grid>
          </form>
          <br /><br />
          {data !== null && (
            <Grid container spacing={2}>
              <Grid item xs>
                <Viewfield label="Applicant Name" name={data?.applicantName} />
                <Viewfield label="Payment Status" name={data?.paymentStatus} />
              </Grid>
              <Grid item xs>
                {isPayment ? (
                  <Button style={{ backgroundColor: '#009688' }} color="primary" variant="contained" onClick={makePayment}>Make Payment</Button>
                ) : (
                  <Button color="primary" variant="contained" onClick={downloadPdf}>Download Form</Button>
                )}
              </Grid>
            </Grid>
          )}
        </Container>
      </Grid>
    </Grid>
  );
};

export default CivilConferenceLookup;
